import request from "superagent";
import Promise from "promise";

export default {
  getItems(pageId, page, lang, categories) {
    let categoryFilter = "";
    if (categories?.length) {
      if (typeof categories === "string") {
        categoryFilter = `&categories=${categories}`;
      } else {
        categories.map((x) => {
          categoryFilter = `${categoryFilter}&categories=${x}`;
        });
      }
    }
    var targetUrl = `/umbraco/api/ListPage/GetListItems?pageId=${pageId}&lang=${lang}&page=${page}${categoryFilter}`;

    return new Promise((resolve, reject) => {
      request.get(targetUrl).end((error, response) => {
        if (response.ok) {
          resolve(response.body);
        } else {
          reject("Error");
        }
      });
    });
  },
  getAllCategories(pageId, lang) {
    var targetUrl = `/umbraco/api/ListPage/GetAllCategories?pageId=${pageId}&lang=${lang}`;

    return new Promise((resolve, reject) => {
      request.get(targetUrl).end((error, response) => {
        if (response.ok) {
          resolve(response.body);
        } else {
          reject("Error");
        }
      });
    });
  },
};
